<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import IdSearchHeader from '@/components/ui/IdSearchHeader.vue';
import CardTable from '@/components/cards/CardTable.vue';
import { useCardSearches } from '@/components/cards/cardSearches';
import {
  AccountActions,
  CardActions,
  CardTokenActions,
} from '@/integrations/Immersve/auth/actions';

const route = useRoute();
const searches = useCardSearches();
const selected = ref<string>();

const accountId = computed(() =>
  typeof route.query.account === 'string' ? route.query.account : ''
);
</script>

<template>
  <SidebarLayout>
    <!-- Listing cards is an account read, not a card read: amethyst checks
    account:read on the account in the path. A user who can only read cards or
    their tokens is let in too, to search by card ID instead. Each is asked for
    on any account, as there is none to ask about until one is searched. -->
    <SecurityTrim
      :actions="[AccountActions.Read, CardActions.Read, CardTokenActions.Read]"
      account-id="*"
      match="any"
    >
      <div class="px-4 py-6 md:px-8" data-test="screen-cards">
        <IdSearchHeader v-model:selected="selected" :searches="searches" />
        <template v-if="selected === 'account'">
          <CardTable v-if="accountId" :account-id="accountId" />
          <p v-else class="text-sm text-gray-500" data-test="cards-prompt">
            Enter an account ID to list its cards.
          </p>
        </template>
        <p v-else class="text-sm text-gray-500" data-test="card-prompt">
          Enter a card ID to see its details and tokens.
        </p>
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
